var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-65 9 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.459 190.751L100.094 195.978L99.9352 192.671L97.4779 142.076L95.6063 103.569C95.0009 91.2313 105.349 81.1513 117.687 82.058L283.631 94.218C294.032 94.9646 302.203 103.356 302.72 113.738L303.61 131.925L306.067 182.858L306.459 190.751Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.068 182.857C276.223 186.857 241.409 190.004 204.194 191.799C166.158 193.648 130.491 193.844 99.9339 192.67L97.4766 142.075C127.766 137.95 163.291 134.697 201.343 132.866C238.562 131.07 273.499 130.839 303.611 131.924L306.068 182.857Z",
    fill: "#5E93D1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M216.892 382.906L215.198 324.532C215.198 324.532 286.241 330.18 301.44 322.298C301.44 322.298 320.012 226.748 297.86 173.834L297.412 171.772L147.491 157.818L137.461 238.002C132.411 223.129 92.3567 208.422 81.4606 229.72C57.852 275.869 142.272 306.943 142.272 306.943L133.699 383.608",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    opacity: 0.398112,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.198 324.532L167.294 314.276L214.968 346.432L215.198 324.532Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.716 229.141L271.27 269.55L251.429 269.802L254.716 229.141Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.841 240.624C236.826 246.065 233.208 251.274 227.757 252.257C222.306 253.242 217.091 249.63 216.104 244.188C215.118 238.746 218.738 233.539 224.187 232.554C229.638 231.569 234.855 235.182 235.841 240.624Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.908 240.624C288.893 246.065 285.274 251.274 279.823 252.257C274.373 253.242 269.157 249.63 268.171 244.188C267.184 238.746 270.804 233.539 276.253 232.554C281.704 231.569 286.921 235.182 287.908 240.624Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.132 281.244C234.132 281.244 241.064 292.471 254.799 291.52L234.132 281.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M234.132 281.244C234.132 281.244 241.064 292.471 254.799 291.52",
    stroke: "#252535",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.839 203.548L303.479 191.415C299.406 175.275 177.01 181.437 177.01 181.437L178.678 203.145L176.619 213.521C77.5811 216.354 0.72978 207.715 0.00516158 192.797C-0.78547 176.52 89.3536 158.932 201.337 153.512C313.318 148.093 404.739 156.895 405.53 173.172C406.057 184.054 365.946 195.522 305.839 203.548L305.839 203.548Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.469 263.069C154.319 262.728 154.162 262.382 153.997 262.029C138.363 228.626 110.954 221.679 103.387 220.372C102.095 209.561 101.109 200.92 101.109 200.92C99.9002 186.147 177.008 181.436 177.008 181.436C177.008 181.436 184.535 251.023 179.781 256.961C176.823 260.662 166.416 262.374 154.469 263.069Z",
    fill: "#19141E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.14ea054d.svg";
export { ForwardRef as ReactComponent };